import React from 'react';
export function ProblemSection() {
  return <section className="w-full px-4" data-id="element-145">
      {/* Part 1 — White */}
      <div className="max-w-2xl mx-auto py-14 border-t border-gray-200" data-id="element-146">
        <p className="text-center text-lg font-bold text-gray-500 uppercase tracking-wider mb-4" data-id="element-147">
          Si sos padre o madre, dejame hacerte una pregunta honesta
        </p>

        <h2 className="text-3xl md:text-4xl font-black text-center text-black mb-8 leading-tight" data-id="element-148">
          ¿Te pasa que te sentás a ayudar a tu hijo… y después de unos minutos
          todo termina en <span className="text-red-600" data-id="element-149">frustración</span>?
        </h2>

        <div className="max-w-xl mx-auto text-lg md:text-xl text-gray-700 leading-relaxed space-y-4 mb-10" data-id="element-150">
          <p data-id="element-151">No porque no te importe. No porque no quieras ayudar.</p>
          <p data-id="element-152">
            Sino porque cada vez parece <strong data-id="element-153">empezar desde cero.</strong>
          </p>
          <p data-id="element-154">
            Le explicás… no entiende. Se distrae. Se frustra.{' '}
            <strong data-id="element-155">Vos también.</strong>
          </p>
          <p data-id="element-156">
            Y ese momento que debería ayudar…{' '}
            <span className="bg-yellow-200 px-1 font-bold" data-id="element-157">
              termina siendo tensión.
            </span>
          </p>
        </div>
      </div>

      {/* Part 2 — Black */}
      <div className="bg-black text-white py-14 -mx-4 px-4" data-id="element-158">
        <div className="max-w-2xl mx-auto text-center" data-id="element-159">
          <p className="text-lg font-bold text-gray-400 uppercase tracking-widest mb-4" data-id="element-160">
            El problema que nadie te explica
          </p>

          <h3 className="text-3xl md:text-5xl font-black text-yellow-400 mb-4" data-id="element-161">
            No es tu hijo. Y tampoco sos vos.
          </h3>

          <p className="text-2xl font-black text-red-400 mb-8" data-id="element-162">
            Es que nadie te enseñó:
          </p>

          <ul className="text-left max-w-md mx-auto space-y-3 text-lg md:text-xl font-medium mb-10" data-id="element-163">
            <li className="flex items-start" data-id="element-164">
              <span className="text-yellow-400 mr-3 flex-shrink-0" data-id="element-165">•</span>
              cómo funciona realmente el aprendizaje infantil
            </li>
            <li className="flex items-start" data-id="element-166">
              <span className="text-yellow-400 mr-3 flex-shrink-0" data-id="element-167">•</span>
              cómo acompañar sin generar presión
            </li>
            <li className="flex items-start" data-id="element-168">
              <span className="text-yellow-400 mr-3 flex-shrink-0" data-id="element-169">•</span>
              cómo explicar para que entienda de verdad
            </li>
          </ul>

          <p className="text-lg font-bold text-gray-400 uppercase tracking-widest mb-6" data-id="element-170">
            Entonces todo se repite:
          </p>

          <p className="text-xl md:text-2xl font-black text-yellow-400 leading-loose mb-10" data-id="element-171">
            Intentás ayudar → no funciona → hay enojo → evitás el momento →{' '}
            <span className="text-red-400" data-id="element-172">vuelve a pasar</span>
          </p>

          <p className="text-xl md:text-2xl font-bold text-gray-300 italic" data-id="element-173">
            Y queda esa sensación constante de:
            <br data-id="element-174" />
            <span className="text-white text-2xl md:text-3xl font-black not-italic block mt-2" data-id="element-175">
              "No lo estoy ayudando como debería"
            </span>
          </p>
        </div>
      </div>
    </section>;
}